module.exports = __webpack_public_path__ + "static/media/navigation-background.af6f7784.png";